import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subject, catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonApiResponse } from 'src/app/models/common-api-response.model';
import {
  MarkUserNotificationsReadPayload,
  UserNotificationsPayload,
  UserNotificationsResponse
} from 'src/app/models/user-notification.model';


@Injectable({providedIn: 'root'})
export class NotificationService {

  private host = environment.base_url;

  private notificationDeleteSubject = new Subject<any>();
  public notificationDelete$ = this.notificationDeleteSubject.asObservable();

  public markedAsReadSubject = new Subject<any>();
  public markedAsRead$ = this.markedAsReadSubject.asObservable();


  constructor(private _httpClient: HttpClient) { }

  private handleError(err: HttpErrorResponse) {
    return throwError(() => ({error: err.error, status: err.status}));
  }

  public triggerNotificationDelete(notificationId: string) {
    this.notificationDeleteSubject.next(notificationId);
  }

  public triggerMarkedAsRead(notificationId: string) {
    this.markedAsReadSubject.next(notificationId);
  }

  getNotificationById(notificationId: string) {
    return this._httpClient.get<any>(this.host + '/notification/get/' + notificationId).pipe(
      catchError(this.handleError)
    )
  }

  getAllNotifications(filter: string) {
    return this._httpClient.get<CommonApiResponse>(this.host + '/notifications/get/' + filter).pipe(
      catchError(this.handleError)
    )
  }

  getUserNotifications(payload: UserNotificationsPayload) {
    return this._httpClient.post<UserNotificationsResponse>(this.host + '/notifications', payload).pipe(
      catchError(this.handleError)
    )
  }

  getNotificationsByDevice(device_id: string, filter: string) {
    return this._httpClient.get<any>(this.host + '/notifications_by_device/get/' + device_id + '/' + filter).pipe(
      catchError(this.handleError)
    )
  }

  notificationDelete(notificationId: string) {
    return this._httpClient.delete<any>(this.host + '/notification/delete/user/' + notificationId).pipe(
      catchError(this.handleError)
    )
  }
  notificationDeleteAll() {
    return this._httpClient.delete<any>(this.host + '/notifications').pipe(
      catchError(this.handleError)
    )
  }

  notificationMarkAllRead() {
    return this._httpClient.get<any>(this.host + '/notifications/clear').pipe(
      catchError(this.handleError)
    )
  }
  notificationMarkRead(notificationId: string) {
    return this._httpClient.get<any>(this.host + '/notification/clear/user/' + notificationId).pipe(
      catchError(this.handleError)
    )
  }

  markUserNotificationsRead(payload: MarkUserNotificationsReadPayload) {
    return this._httpClient.post<any>(this.host + '/notifications/mark', payload).pipe(
      catchError(this.handleError)
    )
  }

  notificationMarkGroupRead(notificationGroupId: string) {
    return this.markUserNotificationsRead({
      notification_groups: [notificationGroupId],
      mark_all_as_read: null
    });
  }

  notificationMarkAllGroupsRead() {
    return this.markUserNotificationsRead({
      notification_groups: null,
      mark_all_as_read: true
    });
  }

  createTestNotifications() {
    return this._httpClient.get<any>(this.host + '/test_notification/create').pipe(
      catchError(this.handleError)
    )
  }

  notificationBatchDelete(notificationIds: string[]) {
    return this._httpClient.post<any>(this.host+'/notification/delete/user/batch',{notif_id_list : notificationIds}).pipe(
      catchError(this.handleError)
    );
  }

  notificationBatchMarkRead(notificationIds: string[]) {
    return this._httpClient.post<any>(this.host+'/notification/clear/user/batch', { notif_id_list: notificationIds }).pipe(
      catchError(this.handleError)
    );
  }
  

}
